import React, { useState } from "react";
import { Tabs, Grid, Text, Group, Title, Button, Divider, Stack } from "@mantine/core";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import ShipmentOperationsMilestones from "../../components/project/Shipment.OperationsMilestones/Shipment.OperationsMilestones";
import ShipmentLogisticsMilestones from "../../components/project/Shipment.LogisticsMilestones/Shipment.LogisticsMilestones";
import ShipmentDetails from "../../components/project/Shipment.ShipmentDetails/Shipment.ShipmentDetails";
import ContainerDetails from "../../components/project/Shipment.ContainerDetails/Shipment.ContainerDetails";
import DocumentDetails from "../../components/project/Shipment.DocumenDetails/Shipment.DocumentDetails";
import CarbonFootprintDetails from "../../components/project/Shipment.CarbonFootprintDetails/Shipment.CarbonFootprintDetails";
import useUserStore from "../../data/User.store";

import { useShipmentContainersData, useShipmentDetailsData } from "../../api/Shipment.ShipmentDetails/Shipment.ShipmentDetails.hooks";
import { useShipmentDocumentsData, useDocumentData } from "../../api/Shipment.DocumentDetails/Shipment.DocumentDetails.hooks";
import { useCarbonFootprintDetailsData } from "../../api/Shipment.CarbonFootprintDetails/Shipment.CarbonFootprintDetails.hooks";
import LoaderDefault from "../../components/common/Loader.default/Loader.default";
import { ArrowLeft } from "tabler-icons-react";
import { IDocumentDetailsData } from "../../api/Shipment.DocumentDetails/Shipment.DocumentDetails.types";

function ShippingTimelines() {
  const { user, logout } = useUserStore();
  const { shipmentNumber } = useParams();
  const [document, setDocument] = useState<IDocumentDetailsData | undefined>(undefined);;
  const { isLoading: isLoadingContainerDetails, data: containerDetails } = useShipmentContainersData(shipmentNumber);
  const { isLoading: isLoadingDocumentDetails, data: documentDetails } = useShipmentDocumentsData(shipmentNumber, logout);
  const { isLoading: isLoadingShipmentDetails, data: shipmentDetails } = useShipmentDetailsData(shipmentNumber);
  const { isLoading: isLoadingCarbonFootprintDetails, data: carbonFootprintDetails } = useCarbonFootprintDetailsData(shipmentNumber);
  const { isLoading: isLoadingDocumentsDetails, data: documentsDetails } = useDocumentData(document, logout);
  const navigate = useNavigate();

  if (
    isLoadingContainerDetails ||
    isLoadingShipmentDetails ||
    isLoadingDocumentDetails ||
    isLoadingDocumentDetails ||
    isLoadingCarbonFootprintDetails
  ) {
    return <LoaderDefault text="Loading data..." />
  }

  function onContainerClick(containerId: string) {
    // TODO: Navigate to Container page upon container click
    console.log('Container Click with ID: ', containerId);
  }

  function onDocumentClick(document: IDocumentDetailsData) {
    // TODO: Navigate to Container page upon container click
    console.log('Document Click with ID: ', document.id);
    setDocument(document);
  }

  return (
    <Stack>
      <Group position="apart">
        <Title order={3} style={{ color: "#C1C2C5" }}>Shipment Details</Title>
        <Button leftIcon={<ArrowLeft />} color="blue" onClick={() => navigate("/shipment-tracking/shipments")}>
          Back to Shipment Query Results
        </Button>
      </Group>
      <Divider />
      <Grid>
        <Grid.Col md={6} lg={2}>
          <ShipmentOperationsMilestones referenceNumber={shipmentNumber} />
        </Grid.Col>
        <Grid.Col md={6} lg={2}>
          <ShipmentLogisticsMilestones referenceNumber={shipmentNumber} />
        </Grid.Col>
        <Grid.Col md={6} lg={8}>
          <Tabs color="gray">
            <Tabs.Tab label="Shipment Details">
              <ShipmentDetails shipmentDetails={shipmentDetails} />
            </Tabs.Tab>
            <Tabs.Tab label="Container Details">
              {containerDetails ?
                <ContainerDetails containers={containerDetails} onContainerClick={onContainerClick} /> :
                <Text color="white">No Containers exist for this Shipment</Text>
              }
            </Tabs.Tab>
            <Tabs.Tab label="Document Details">
              {documentDetails ?
                <DocumentDetails documents={documentDetails} onDocumentClick={onDocumentClick} /> :
                <Text color="white">No Documents exist for this Shipment</Text>
              }
            </Tabs.Tab>
            <Tabs.Tab label="Carbon Footprint Details">
              {carbonFootprintDetails ?
                <CarbonFootprintDetails carbonFootprints={carbonFootprintDetails} /> :
                <Text color="white">No Carbon Footprint Details exist for this Shipment</Text>
              }
            </Tabs.Tab>
          </Tabs>
        </Grid.Col>
      </Grid>
    </Stack>

  )
}

export default ShippingTimelines;